import { GET_PRODUCT_DATA,LOAD_MORE_PRODUCT_DATA,CHANGE_PRODUCT_INCOMING} from '../actions/types';

const products_data = {
  data: [],
  origData:[],
  dataCount:0,
  dataNext:null,
  dataPrevious:null,
  editModalOpen: false,
  previewModalOpen: false,
  item:[],
  currentProps:null,

};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = products_data, action) => {
  var dataArray;
  switch (action.type) {   
    case GET_PRODUCT_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        origData:newdata,
        data: newdata,
        dataCount:newdata.length,
        lastVisible:lastVisible,
        currentProps:action.payload.currentProps
      };

    case LOAD_MORE_PRODUCT_DATA:         
      var  newdata = action.payload.dataArray
      var  lastVisible = action.payload.lastVisible
      return {  
        ...state,
        origData:newdata.concat(state.origData),
        data: newdata.concat(state.data),
        dataCount:newdata.concat(state.origData).length,
        lastVisible:lastVisible,
     
      };

    case CHANGE_PRODUCT_INCOMING:         
      var  prodID = action.payload.productID
      var  incoming_count = action.payload.incoming_count
      var newdata = state.data.map(item =>{
        if(item.id == prodID){
          var newItem={
            ...item,
            incoming_count:incoming_count
          }
          return(newItem)
        }else{
          return(item)
        }

      })
      return {  
        ...state,
        data: newdata,
      };
 

    default:
      return state;
  }
};
